import { useState, useEffect, useCallback } from 'react';

interface UserFunctionalities {
  [key: string]: boolean;
}

export const useUserFunctionalities = () => {
  const [functionalities, setFunctionalities] = useState<UserFunctionalities>(() => {
    // Initialize state from localStorage on mount
    const userString = localStorage.getItem('accessModules');
    if (userString) {
      try {
        return JSON.parse(userString);
      } catch (error) {
        console.error('Error parsing user data:', error);
        return {};
      }
    }
    return {};
  });

  const loadFunctionalities = useCallback(() => {
    const userString = localStorage.getItem('accessModules');
    if (userString) {
      try {
        const user = JSON.parse(userString);
        setFunctionalities(user);
      } catch (error) {
        console.error('Error parsing user data:', error);
        setFunctionalities({});
      }
    } else {
      setFunctionalities({});
    }
  }, []);

  useEffect(() => {
    // Add event listener for storage changes
    window.addEventListener('storage', loadFunctionalities);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('storage', loadFunctionalities);
    };
  }, [loadFunctionalities]);

  const hasFunctionality = useCallback((functionality: string): boolean => {
    return !!functionalities[functionality];
  }, [functionalities]);

  return { functionalities, hasFunctionality, reloadFunctionalities: loadFunctionalities };
};